var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHumanResources = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Human-Resources-Employee--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Human Resources Employee Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.88 20.44a0.25 0.25 0 0 1 -0.17 -0.21 0.26 0.26 0 0 1 0.12 -0.24 3.52 3.52 0 1 0 -3.64 0 0.26 0.26 0 0 1 0.12 0.24 0.25 0.25 0 0 1 -0.17 0.21 5.91 5.91 0 0 0 -3.34 2.82 0.52 0.52 0 0 0 0 0.5 0.5 0.5 0 0 0 0.43 0.24h9.55a0.49 0.49 0 0 0 0.42 -0.24 0.52 0.52 0 0 0 0 -0.5 6 6 0 0 0 -3.32 -2.82Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93 5.55a1 1 0 0 0 -0.93 -0.61h-1.49a0.24 0.24 0 0 1 -0.23 -0.16l-0.85 -2.23a1.06 1.06 0 0 0 -1.86 0L18 4l0 0.07a2.51 2.51 0 0 1 -1.24 2.06 0.25 0.25 0 0 0 -0.09 0.3l0.23 0.53a2.5 2.5 0 0 1 -0.62 2.86A2.11 2.11 0 0 1 16 10a0.27 0.27 0 0 0 -0.09 0.3 1 1 0 0 0 0.27 0.37 1 1 0 0 0 1.19 0.14l2 -1.1a0.23 0.23 0 0 1 0.25 0l1.95 1.1a1 1 0 0 0 0.51 0.13 1 1 0 0 0 0.69 -0.27A1 1 0 0 0 23 9.52l-0.7 -1.65a0.27 0.27 0 0 1 0.09 -0.31l1.3 -0.91a1 1 0 0 0 0.24 -1.1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72 9.81A2.5 2.5 0 0 1 7.1 7l0.22 -0.52a0.26 0.26 0 0 0 -0.08 -0.31A2.59 2.59 0 0 1 6 4l-0.56 -1.45a1 1 0 0 0 -1.85 0l-0.87 2.23a0.25 0.25 0 0 1 -0.23 0.16H1a1 1 0 0 0 -0.93 0.61 1 1 0 0 0 0.3 1.16l1.24 0.86a0.24 0.24 0 0 1 0.08 0.3L1 9.52a1 1 0 0 0 0.25 1.15 1 1 0 0 0 1.2 0.14l1.95 -1.1a0.23 0.23 0 0 1 0.25 0l2 1.1a1.08 1.08 0 0 0 0.52 0.13 1 1 0 0 0 0.68 -0.27 0.9 0.9 0 0 0 0.15 -0.36 0.24 0.24 0 0 0 0 -0.31 1.59 1.59 0 0 1 -0.28 -0.19Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.81 5.9a0.25 0.25 0 0 1 0.09 -0.31l1.3 -0.91a1 1 0 0 0 0.23 -1.1A1 1 0 0 0 15.5 3H14a0.25 0.25 0 0 1 -0.24 -0.16L12.94 0.58A1 1 0 0 0 12 0a1 1 0 0 0 -0.95 0.58l-0.84 2.23A0.25 0.25 0 0 1 10 3H8.5a1 1 0 0 0 -0.93 0.61 1 1 0 0 0 0.3 1.16l1.23 0.85a0.25 0.25 0 0 1 0.09 0.31l-0.72 1.61A1 1 0 0 0 9.41 9a1 1 0 0 0 0.51 -0.13l2 -1.11a0.26 0.26 0 0 1 0.24 0l2 1.11a1 1 0 0 0 0.51 0.13 1 1 0 0 0 0.69 -0.27 1 1 0 0 0 0.25 -1.16Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHumanResources);
export default ForwardRef;